import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=43c421f6&"
import script from "./ModalIframe.vue?vue&type=script&lang=js&"
export * from "./ModalIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c421f6')) {
      api.createRecord('43c421f6', component.options)
    } else {
      api.reload('43c421f6', component.options)
    }
    module.hot.accept("./ModalIframe.vue?vue&type=template&id=43c421f6&", function () {
      api.rerender('43c421f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ModalIframe.vue"
export default component.exports